module.exports = __webpack_public_path__ + "acf3dcb7ff752b5296ca23ba2c7c2606.svg";